import React, { useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import Card from "../../../components/Card";
import { formatDateTimeLocalDate } from "../../../utilities/Utils";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";

const ExpandableComponentSmkhpFinal = ({ data }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [listSmkhpFile, setListSmkhpFile] = useState([])
    const [loading, setLoading] = useState(false)

    const columns = [
        {
            name: 'File',
            cell: row => 
            (
                <div className="row">
                    <div className="col-12">
                        <a href={row['dokPath']} target="_blank" rel="noopener noreferrer">{row['dokName']}</a>
                    </div>
                </div>
            )
        },
        {
            name: 'Tanggal Dibuat',
            cell: row => formatDateTimeLocalDate(row['createdDate'])
        }
    ]

    useEffect(() => {
        if (!data?.nomorAju || !data?.noHcMutu) {
            return
        }
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const resFile = await transaksiService.listSmkhpFile(data?.nomorAju, data?.noHcMutu)
                setListSmkhpFile(resFile?.data?.data)
            } catch (error) {
                setListSmkhpFile([])
            }
            setLoading(false)
        }
        fetchAllData()
    }, [transaksiService, data])

    return (
        <>
            <Card>
                <Card.Body>
                    <div className="table-responsive border-bottom my-3">
                        {(loading && <Spinner />)}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listSmkhpFile}
                            highlightOnHover
                            pagination
                            persistTableHead={true}
                        />
                    </div>
                </Card.Body>
            </Card>
        </>
    )

}

export default ExpandableComponentSmkhpFinal